import { Box } from '@mui/material';

import { LoadingView } from '@/ui/components/LoadingView';

export function TourTraveListBodyLoading() {
  return (
    <Box sx={{ my: 5 }}>
      <LoadingView />
    </Box>
  );
}
